import apiClient from './apiClient';
import type { ApiResponse } from '../types';

const API_TYPE = 'api' as const;

interface TradingStatusResponse {
  trading_enabled: boolean;
}

class TradingStatusService {
  async getStatus(): Promise<boolean> {
    try {
      const response = await apiClient.get<ApiResponse<TradingStatusResponse>>(
        '/user/trading-status',
        undefined,
        API_TYPE
      );
      const wrapped = response as ApiResponse<TradingStatusResponse>;
      return wrapped.data?.trading_enabled ?? true;
    } catch {
      return true; // default to enabled on error
    }
  }

  async setStatus(enabled: boolean): Promise<boolean> {
    const response = await apiClient.put<ApiResponse<TradingStatusResponse>>(
      '/user/trading-status',
      { trading_enabled: enabled },
      undefined,
      API_TYPE
    );
    const wrapped = response as ApiResponse<TradingStatusResponse>;
    if (!wrapped.success) {
      throw new Error(wrapped.message || 'Failed to update trading status');
    }
    return wrapped.data?.trading_enabled ?? enabled;
  }
}

const tradingStatusService = new TradingStatusService();
export default tradingStatusService;
